import { CORE, MESSAGING } from 'core/datasets/action';
import { RequestAssistantConversationAction, SelectChannelAction } from 'messaging/types/redux/messagingActions';
import { put, select } from 'redux-saga/effects';
import { AssistantConversationQuery } from '../../gql/useQueryChannels';
import { messagingSelectors } from '../../redux/messagingSelectors';
import { isObject } from 'lodash';

function* fetchAssistantConversation(channelId: string | null): Generator {
    if (!channelId) {
        return;
    }

    const channelsMap = yield select(messagingSelectors.channelsMap);

    if (channelsMap && isObject(channelsMap)) {
        // @ts-ignore
        const selectedChannel = channelsMap[channelId];

        if (selectedChannel && selectedChannel.channelType !== 'service_request') {
            yield put({
                type: CORE.MAKE_GRAPHQL_REQUEST,
                payload: {
                    query: AssistantConversationQuery,
                    variables: { messagingChannelId: channelId },
                    callbackType: MESSAGING.FETCHED_ASSISTANT_CONVERSATION,
                },
            });
        }
    }
}

export function* getAssistantConversation(action: SelectChannelAction): Generator {
    yield* fetchAssistantConversation(action.payload);
}

export function* requestAssistantConversation(action: RequestAssistantConversationAction): Generator {
    yield* fetchAssistantConversation(action.payload);
}
